$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('link-landing-milestone')) {
    customElements.define(
      'link-landing-milestone',
      class linkLandingMilestone extends HTMLElement {
        constructor() {
          super();
        }
        $this = this;
        connectedCallback() {
          if (window.innerWidth > 1280) {
            gsapLazy(() => {
              this.init();
            });
          } else {
            this.initMobile();
          }
        }

        init() {
          // 注册 ScrollTrigger 插件
          gsap.registerPlugin(ScrollTrigger);

          const detailEl = this.querySelector('.link-landing-milestone__detail');
          const milestoneEl = this.querySelector('.link-landing-milestone');

          const firstEl = this.querySelector('.link-landing-milestone__pc-first');

          // 初始设置圆角
          gsap.set(firstEl, {
            borderTopLeftRadius: 60,
            borderTopRightRadius: 60,
          });

          // 触发动画
          ScrollTrigger.create({
            trigger: detailEl,
            start: 'top top',
            end: 'bottom top',
            scrub: true,
            onUpdate: (self) => {
              const progress = self.progress;

              // 动态渐变
              gsap.to(milestoneEl, {
                backgroundColor: `rgba(0, 0, 0, ${0.4 * progress})`,
                overwrite: 'auto',
                duration: 0.01,
              });

              gsap.to(firstEl, {
                borderTopLeftRadius: 60 * (1 - progress),
                borderTopRightRadius: 60 * (1 - progress),
                overwrite: 'auto',
                duration: 0.01,
              });
            },
          });

          // 设置滚动触发器
          this.querySelectorAll('.milestone-box').forEach((box) => {
            const triggerName = box.id;

            ScrollTrigger.create({
              trigger: box,
              start: 'top center',
              end: 'bottom center',
              onEnter: () => setActiveAnchor(triggerName),
              onEnterBack: () => setActiveAnchor(triggerName),
            });
          });

          // 设置点击事件跳转
          this.querySelectorAll('.anchor').forEach((anchor) => {
            anchor.addEventListener('click', (e) => {
              e.preventDefault();
              const targetId = anchor.dataset.trigger; // e.g., "milestone-box1"
              const containerDom = this.querySelector('.link-landing-milestone__pc');
              const match = targetId.match(/(\d+)$/); // 提取末尾数字
              if (!match || !containerDom) return;

              const index = parseInt(match[1], 10) - 1; // 索引从 0 开始
              const offsetY = 0; // 预留顶部空间

              const containerTop = containerDom.getBoundingClientRect().top + window.pageYOffset;
              const extraOffset = index * window.innerHeight * 0.2;
              const targetY = containerTop + index * window.innerHeight + extraOffset - offsetY;

              window.scrollTo({
                top: targetY,
                behavior: 'smooth',
              });
            });
          });

          const setActiveAnchor = (triggerName) => {
            this.querySelectorAll('.anchor').forEach((anchor) => {
              anchor.classList.toggle('active', anchor.dataset.trigger === triggerName);
            });
          };
        }
        initMobile() {
          new Swiper('.link-landing-milestone__mobile_product_swiper', {
            slidesPerView: 'auto',
            spaceBetween: 24,
            scrollbar: {
              el: '.link-landing-milestone__mobile_product_swiper_scrollbar',
              draggable: true,
            },
          });

          this.initAnchorNavigation();
        }
        initAnchorNavigation() {
          const $milestoneAnchors = $('.link-landing-milestone__mobile_anchor');
          const $milestoneElements = $('[id^="milestone_"]');
          const $navigationBar = $('.link-landing-milestone__mobile_navigation');
          const $header = $('#lt-header');

          // 缓存导航栏原始位置
          let navigationOriginalTop = null;
          let lastHeaderHeight = 0;
          let lastStickyState = false;
          let transitionEnabled = false;

          // 实时获取头部导航高度（考虑动态变化）
          const getHeaderHeight = () => {
            if ($header.length) {
              const isVisible = $header.attr('data-scrollshow') === 'true';
              return isVisible ? $header.find('#header-01').outerHeight() || 0 : 0;
            }
            return 0;
          };

          // 启用/禁用过渡效果
          const setTransition = (enabled) => {
            if (enabled && !transitionEnabled) {
              $navigationBar.css({
                transition: 'top 300ms ease-in-out, background-color 300ms ease-in-out, box-shadow 300ms ease-in-out',
              });
              // 同时为文字颜色添加过渡效果
              $navigationBar.find('.link-landing-milestone__mobile_anchor_text').css({
                transition: 'color 300ms ease-in-out',
              });
              transitionEnabled = true;
            } else if (!enabled && transitionEnabled) {
              $navigationBar.css('transition', '');
              $navigationBar.find('.link-landing-milestone__mobile_anchor_text').css('transition', '');
              transitionEnabled = false;
            }
          };

          // 初始化导航栏原始位置
          const initNavigationPosition = () => {
            if (navigationOriginalTop === null) {
              setTransition(false);
              const originalStyles = {
                position: $navigationBar.css('position'),
                top: $navigationBar.css('top'),
                backgroundColor: $navigationBar.css('background-color'),
                boxShadow: $navigationBar.css('box-shadow'),
              };
              $navigationBar.css({
                position: 'static',
                top: 'auto',
                'background-color': '',
                'box-shadow': '',
              });
              navigationOriginalTop = $navigationBar.offset().top;
              $navigationBar.css(originalStyles);
            }
          };

          const updateNavigationStyle = () => {
            const scrollTop = $(window).scrollTop();
            const currentHeaderHeight = getHeaderHeight();
            initNavigationPosition();
            const stickyTriggerPoint = navigationOriginalTop - currentHeaderHeight;
            const shouldStick = scrollTop >= stickyTriggerPoint;
            const stateChanged = shouldStick !== lastStickyState;
            const headerHeightChanged = currentHeaderHeight !== lastHeaderHeight;
            if (stateChanged || headerHeightChanged) {
              setTransition(true);
              lastStickyState = shouldStick;
              lastHeaderHeight = currentHeaderHeight;
              if (shouldStick) {
                $navigationBar.css({
                  top: currentHeaderHeight + 'px',
                  'background-color': '#181818',
                  'box-shadow': '0 4px 4px 0 rgba(255, 255, 255, 0.16)',
                  'z-index': '100',
                });
              } else {
                $navigationBar.css({
                  top: '0px',
                  'background-color': '#ffffff',
                  'box-shadow': 'none',
                  'z-index': '100',
                });
              }
            }
          };

          // 更新active状态
          const updateActiveState = () => {
            const scrollTop = $(window).scrollTop();
            const navigationHeight = $navigationBar.outerHeight() || 0;
            const headerHeight = getHeaderHeight();
            const totalOffset = navigationHeight + headerHeight;
            let activeIndex = 0;

            $milestoneElements.each(function (index) {
              const elementTop = $(this).offset().top - totalOffset - 50;

              if (scrollTop >= elementTop) {
                activeIndex = index;
              }
            });

            $milestoneAnchors.each(function (index) {
              if (index === activeIndex) {
                $(this).addClass('active');
              } else {
                $(this).removeClass('active');
              }
            });
          };

          // 综合更新函数
          const handleScroll = () => {
            updateNavigationStyle();
            updateActiveState();
          };

          // 节流函数
          const throttle = (func, limit) => {
            let inThrottle;
            return function () {
              const args = arguments;
              const context = this;
              if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => (inThrottle = false), limit);
              }
            };
          };

          // 窗口大小变化时重新计算原始位置
          const handleResize = () => {
            // 临时禁用过渡效果以避免调整大小时的动画
            setTransition(false);
            navigationOriginalTop = null;
            lastStickyState = false;
            lastHeaderHeight = 0;
            setTimeout(() => {
              handleScroll();
            }, 50);
          };

          // 监听滚动事件
          $(window).on('scroll', throttle(handleScroll, 16));

          // 监听窗口大小变化
          $(window).on('resize', throttle(handleResize, 100));

          // 使用 MutationObserver 监听 header 属性变化
          if ($header.length) {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-scrollshow') {
                  // header 显示/隐藏状态发生变化，立即更新导航样式
                  // 这里会触发过渡效果
                  setTimeout(updateNavigationStyle, 10);
                }
              });
            });

            observer.observe($header[0], {
              attributes: true,
              attributeFilter: ['data-scrollshow'],
            });
          }

          // 初始化
          setTimeout(() => {
            handleScroll();
          }, 50);
        }
      }
    );
  }
});
